import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { ItemService } from './video-tutorial.service';
import { FormatNumberInputProvider } from 'src/app/shared/components/format-number-input/format-number-input.component';
import { SystemSettingStorageService } from 'src/app/shared/model/system-setting-storage.service';
import { LocalStorageService } from 'ng2-webstorage';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { videoTutorialRoute } from './video-tutorial.route';

import { VideoTutorialComponent } from './video-tutorial.component';
import { VideoTutorialDetailComponent } from './video-tutorial-detail.component'


const ENTITY_STATES = [
	...videoTutorialRoute,
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule.forRoot(ENTITY_STATES, { useHash: true })
	],
	declarations: [
		VideoTutorialComponent,
		VideoTutorialDetailComponent,
	],
	entryComponents: [
		VideoTutorialComponent,
		VideoTutorialDetailComponent,
	],
	providers: [ItemService,
		FormatNumberInputProvider,
		SystemSettingStorageService,
		LocalStorageService,
		NgbActiveModal
	],
	exports: [

	]
})
export class VideoTutorialModule { }
